import { tokenStore } from '@/shared/auth/token-store';

/**
 * Runs ONCE at module-load time (called from main.tsx) before any React
 * component mounts. If the URL carries `?impersonationToken=...` (the
 * admin-web Impersonate button opens us with it), the token is pulled
 * into the in-memory tokenStore and the query param is stripped from
 * the address bar so the user can navigate freely without leaking the
 * token through Referer headers or the back stack.
 *
 * Why eager (not a React effect): the AuthProvider's first action is to
 * call `useUser`, which hits `/current-user` via apiFetcher. apiFetcher's
 * `ensureAuthBootstrap` short-circuits when `tokenStore.getAccessToken()`
 * is already set — so we need the token in the store BEFORE the first
 * render. A useEffect would race with the initial query.
 */
export function consumeImpersonationTokenFromUrl(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const token = params.get('impersonationToken');
  if (!token) {
    return;
  }

  tokenStore.setAccessToken(token);

  params.delete('impersonationToken');
  const newSearch = params.toString();
  const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
  window.history.replaceState({}, '', newUrl);
}
